import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import get from 'lodash-es/get';
import isObject from 'lodash-es/isObject';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';

var propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  placeholder: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  descriptionPath: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  descriptionValues: PropTypes.object,
  locale: PropTypes.string,
  selected: PropTypes.bool,
  className: PropTypes.string
};
var defaultProps = {
  value: null,
  placeholder: null,
  item: null,
  descriptionPath: null,
  descriptionValues: null,
  locale: null,
  selected: false,
  className: null
};
var TextDescription = function TextDescription(_ref) {
  var initialValue = _ref.value,
    placeholder = _ref.placeholder,
    parentLocale = _ref.locale,
    item = _ref.item,
    descriptionPath = _ref.descriptionPath,
    descriptionValues = _ref.descriptionValues,
    selected = _ref.selected,
    className = _ref.className;
  var _useIntl = useIntl(),
    locale = _useIntl.locale;
  var _useMemo = useMemo(function () {
      var partialValue = initialValue !== null && isObject(initialValue) ? initialValue[parentLocale || locale] || null : initialValue;
      var labelValue = get(item, descriptionPath);
      var partialLabel = labelValue !== null && isObject(descriptionValues) ? descriptionValues[labelValue] || null : labelValue;
      return {
        value: partialValue,
        label: partialLabel
      };
    }, [initialValue, descriptionPath, descriptionValues, item, locale, parentLocale]),
    value = _useMemo.value,
    label = _useMemo.label;
  return label !== null ? /*#__PURE__*/React.createElement("div", {
    className: classNames([_defineProperty({}, className, className !== null)])
  }, /*#__PURE__*/React.createElement("p", {
    className: "d-block m-0 p-0 lh-sm"
  }, value || placeholder), /*#__PURE__*/React.createElement("p", {
    className: classNames(['d-block m-0 p-0 text-opacity-50 lh-sm', {
      'text-body': !selected
    }])
  }, /*#__PURE__*/React.createElement("small", null, label))) : /*#__PURE__*/React.createElement(React.Fragment, null, value || placeholder);
};
TextDescription.propTypes = propTypes;
TextDescription.defaultProps = defaultProps;

export { TextDescription as default };
